import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/data-import",
    name: "Acquisition Import",
    component: () => import("./acquisitionImport.vue"),
  },
  {
    path: "/manage-data-sets",
    name: "Manage Data Sets",
    component: () => import("./manageDatasets.vue"),
  },
  {
    path: "/manage-ticker-symbols",
    name: "Market Data Admin",
    component: () => import("./marketDataAdmin.vue"),
  },
  //Until this is fully tested, keep it at _v2
  {
    path: "/templates_v2",
    name: "Templates",
    component: () => import("./templateManager.vue"),
  },
  {
    path: "/zip-areas",
    name: "Zip Areas",
    component: () => import("./zipGroupingManager.vue"),
  },
] satisfies RouteRecordRaw[];
